import { ComponentPropsWithoutRef, forwardRef, MouseEventHandler } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link, matchPath, useLocation } from 'react-router-dom';
import cn from 'classnames';

type Props = {
  additionalActivePathList?: string[];
  to: string;
} & ComponentPropsWithoutRef<'li'>;

const LNBSubMenuItem = forwardRef<HTMLLIElement, Props>(
  ({ additionalActivePathList, to, children, onClick, ...props }, ref) => {
    const [toPathname] = to.split('?');
    const location = useLocation();
    const activeList = additionalActivePathList ? [...additionalActivePathList, toPathname] : [toPathname];
    const isActivated = activeList.some((path) => matchPath(path, location.pathname));
    const isCurrentPage = matchPath(toPathname, location.pathname);

    const onClickLiHandler: MouseEventHandler<HTMLLIElement> = (e) => {
      e.stopPropagation();
      if (isCurrentPage) {
        e.preventDefault();
      }
      onClick?.(e);
    };

    const onClickAnchorHandler: MouseEventHandler<HTMLAnchorElement> = (e) => {
      if (isCurrentPage) {
        e.preventDefault();
      }
    };

    return (
      <li {...props} ref={ref} className={cn({ on: isActivated })} onClick={onClickLiHandler}>
        <Link
          to={to}
          className="link_sub"
          aria-current={isCurrentPage ? 'page' : undefined}
          onClick={onClickAnchorHandler}
        >
          {children}
        </Link>
      </li>
    );
  }
);

LNBSubMenuItem.displayName = 'LNBSubMenuItem';

export default LNBSubMenuItem;
